import { render, staticRenderFns } from "./QuestionHorizontal.vue?vue&type=template&id=3730a5d7&scoped=true&lang=pug&"
import script from "./QuestionHorizontal.vue?vue&type=script&lang=ts&"
export * from "./QuestionHorizontal.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionHorizontal.vue?vue&type=style&index=0&id=3730a5d7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3730a5d7",
  null
  
)

export default component.exports